var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.34 4.933 9.2 6.043a.2.2 0 0 1-.28 0L7 4.16V12.3a.2.2 0 0 1-.2.2H5.2a.2.2 0 0 1-.2-.2V4.16L3.08 6.044a.2.2 0 0 1-.279 0l-1.14-1.11a.2.2 0 0 1 0-.287l4.2-4.09a.2.2 0 0 1 .279 0l4.2 4.09a.2.2 0 0 1 0 .287Z",
    fill: "#00D186"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(1 0 0 -1 0 12.5)",
    d: "M0 0h12v12H0z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.621846120804c35870521cd7751a554d.svg";
export { ForwardRef as ReactComponent };